import styled from "styled-components";


const TestimonialStyled = styled.div`
    display: flex;
    margin: 3rem auto;
    justify-content: space-between;
    gap: 1rem;
    background:
            linear-gradient(to bottom, rgba(111, 203, 209, 0.5), rgba(111, 203, 209));
    border-radius: 0.625rem;
    width: 100%;
    height: 200px;
    .content{
        display: flex;
        width: fit-content;
        flex-direction: column;
        font-size: 0.8rem;
        gap: 1.5rem;
        padding: 1rem;
        color: #000;
        overflow: hidden;
        
        p{
            display: -webkit-box;
            -webkit-line-clamp: 3;           
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.4;                 
            max-height: calc(1.4em * 3);
            width: 20ch;
        }
    }
    .imageBox{
        width: 250px;
        height: inherit;
        border-top-right-radius: 0.625rem;
        border-bottom-right-radius: 0.625rem;
        overflow: hidden;
        img{
            width: 100%;
            height: inherit;
            object-fit: cover;
            display: block;
        }
    }
    @media only screen and (min-width: 992px) {
        height: 200px;
        .content{
            font-size: 0.8rem;
        }
        .imageBox{
            width: 200px;
           
    }
`;

export default TestimonialStyled;